

module.exports = __webpack_require__.stylable.create(
    "Ribbon3200395074",
    {"classes":{"root":"Ribbon3200395074__root","ribbon":"Ribbon3200395074__ribbon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Ribbon3200395074",
    null
);
